import requester from './requester.js'
import objectUtils from './object_utils.js'
export default {
  update,
  sync,
  deleteList,
  editList,
  activateList,
  createList
}

const DEFAULT_LIST = 'default'
const EMPTY_GUEST_DATA = {
  guestId: null,
  add: {},
  remove: {},
  addProductId: {},
  removeProductId: {},
}

const EMPTY_WISHLIST = {
  lists: {
    default: {}
  },
  product_id_lists: {
    default: {}
  },
  listNames: [DEFAULT_LIST],
}


function update({ handle, productId, variantId, remove, guestId, list } = {}) {
  sync()
  // ensure we store only id's
  variantId = parseInt(variantId)
  frcp.wishlist.profile.id ? updateList(handle, productId, variantId, remove, list) : updateGuest(handle, productId, variantId, remove, guestId, list)

  frcp.wishlist.data['updatedAt'] = new Date().valueOf()
  window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
}

function updateList(handle, productId, variantId, remove, list) {
  list = list || frcp.wishlist.data.activeList

  if (remove) {
    if (productId) removeFromProductIdsList(productId, variantId, list)
    removeFromHandlesList(variantId, list)
  } else {
    frcp.wishlist.data.lists[list][handle] ||= []
    if (frcp.wishlist.data.lists[list][handle].indexOf(variantId) < 0) frcp.wishlist.data.lists[list][handle].push(variantId)

    if (productId) {
      frcp.wishlist.data.product_id_lists[list][productId] ||= []
      if (frcp.wishlist.data.product_id_lists[list][productId].indexOf(variantId) < 0) frcp.wishlist.data.product_id_lists[list][productId].push(variantId)
    }
  }
}

function removeFromProductIdsList(productId, variantId, list) {
  let variants = frcp.wishlist.data.product_id_lists[list][productId]
  if (!variants) return;

  if (variants.length > 1) {
    variants = variants.filter(item => item !== variantId)
    frcp.wishlist.data.product_id_lists[list][productId] = variants
  } else {
    delete frcp.wishlist.data.product_id_lists[list][productId]
  }
}

function removeFromHandlesList(variantId, list) {
  const handlesForVariant = Object.keys(frcp.wishlist.data.lists[list]).filter(handle => frcp.wishlist.data.lists[list][handle].includes(variantId))
  handlesForVariant.forEach(handle => {
    let variants = frcp.wishlist.data.lists[list][handle]

    if (variants.length > 1) {
      variants = variants.filter(item => item !== variantId)
      frcp.wishlist.data.lists[list][handle] = variants
    } else {
      delete frcp.wishlist.data.lists[list][handle]
    }
  })
}

function updateGuest(handle, productId, variantId, remove, list,) {
  updateGuestHandleList(handle, variantId, remove, list)
  updateGuestProductIdList(productId, variantId, remove, list)
}

// assumes handles can be translated. So the same variant can be in multiple lists 
function updateGuestHandleList(handle, variantId, remove, guestId, list) {
  frcp.wishlist.data.guest.guestId = guestId
  frcp.wishlist.data.guest.list = list
  if (remove) {
    frcp.wishlist.data.guest.remove[handle] ||= []
    let addedHandlesForVariant = Object.keys(frcp.wishlist.data.guest.add).filter((h) => frcp.wishlist.data.guest.add[h].includes(variantId))
    // add it to remove if its not added as guest and is not in removed 
    if ((addedHandlesForVariant.length <= 0) && frcp.wishlist.data.guest.remove[handle].indexOf(variantId) < 0) {
      frcp.wishlist.data.guest.remove[handle].push(variantId)
    }

    addedHandlesForVariant.forEach(h => {
      let addedVariants = frcp.wishlist.data.guest.add[h]
      addedVariants = addedVariants.filter(item => item !== variantId)
      frcp.wishlist.data.guest.add[h] = addedVariants
      if (frcp.wishlist.data.guest.add[h].length < 1) delete frcp.wishlist.data.guest.add[handle]
    })
  } else {
    frcp.wishlist.data.guest.add[handle] ||= []
    if (frcp.wishlist.data.guest.add[handle].indexOf(variantId) < 0) {
      frcp.wishlist.data.guest.add[handle].push(variantId)
    }

    let toTemovedHandles = Object.keys(frcp.wishlist.data.guest.remove).filter(h => frcp.wishlist.data.guest.remove[h].includes(variantId))
    toTemovedHandles.forEach(h => {
      let variants = frcp.wishlist.data.guest.remove[h]
      if (!variants) return;

      variants = variants.filter(item => item !== variantId)
      frcp.wishlist.data.guest.remove[h] = variants

      if (frcp.wishlist.data.guest.remove[h].length < 1) delete frcp.wishlist.data.guest.remove[h]
    })
  }
}

function updateGuestProductIdList(productId, variantId, remove, guestId, list) {
  if (!productId) return
  frcp.wishlist.data.guest.guestId = guestId
  frcp.wishlist.data.guest.list = list
  if (remove) {
    frcp.wishlist.data.guest.removeProductId[productId] ||= []
    let addedVariants = frcp.wishlist.data.guest.addProductId[productId] || []
    // add it to remove if its not added as guest and is not in removed 
    if (addedVariants.indexOf(variantId) < 0 && frcp.wishlist.data.guest.removeProductId[productId].indexOf(variantId) < 0) {
      frcp.wishlist.data.guest.removeProductId[productId].push(variantId)
    }

    if (addedVariants.length == 0) return;

    addedVariants = addedVariants.filter(item => item !== variantId)
    frcp.wishlist.data.guest.addProductId[productId] = addedVariants

    if (frcp.wishlist.data.guest.addProductId[productId].length < 1) delete frcp.wishlist.data.guest.addProductId[productId]
  } else {
    frcp.wishlist.data.guest.addProductId[productId] ||= []
    if (frcp.wishlist.data.guest.addProductId[productId].indexOf(variantId) < 0) {
      frcp.wishlist.data.guest.addProductId[productId].push(variantId)
    }

    let variants = frcp.wishlist.data.guest.removeProductId[productId]
    if (!variants) return;

    variants = variants.filter(item => item !== variantId)
    frcp.wishlist.data.guest.removeProductId[productId] = variants

    if (frcp.wishlist.data.guest.removeProductId[productId].length < 1) delete frcp.wishlist.data.guest.removeProductId[productId]
  }
}

function sync() {
  let localStorageWishlist = window.localStorage.getItem('frcp_wishlist')

  if (localStorageWishlist) {
    try {
      localStorageWishlist = JSON.parse(localStorageWishlist)
    } catch (error) {
      localStorageWishlist = EMPTY_WISHLIST
    }
  } else {
    localStorageWishlist = EMPTY_WISHLIST
  }

  if (frcp.wishlist.data.updatedAt) {
    frcp.wishlist.data.updatedAt = new Date(frcp.wishlist.data.updatedAt).valueOf()
  }


  const newCustomer = frcp.wishlist.data.customerId && (localStorageWishlist.customerId != frcp.wishlist.data.customerId)
  const localStorageIsNewer = !frcp.wishlist.data.updatedAt || (localStorageWishlist.updatedAt && (localStorageWishlist.updatedAt > frcp.wishlist.data.updatedAt))

  // new custommer log in, we should take the metafields wishlist as correct
  // same customerId or customer is not logged in  so we should choose the one updated last 
  if (!newCustomer && localStorageIsNewer) {
    frcp.wishlist.data = localStorageWishlist
  }

  // guest data can only come from local storage
  frcp.wishlist.data.guest = localStorageWishlist.guest

  normalizeMultiList()
  syncGuestAndStore()

  return frcp.wishlist.data
}

function normalizeMultiList() {
  frcp.wishlist.data.lists ||= {}
  frcp.wishlist.data.product_id_lists ||= {}
  if (frcp.wishlist.data.items) frcp.wishlist.data.lists[DEFAULT_LIST] = frcp.wishlist.data.items

  frcp.wishlist.data.activeList = frcp.wishlist.data.activeList || DEFAULT_LIST
  frcp.wishlist.data.listNames = frcp.wishlist.data.listNames || [DEFAULT_LIST]

  frcp.wishlist.data.listNames.forEach(list => {
    frcp.wishlist.data.lists[list] ||= {}
    frcp.wishlist.data.product_id_lists[list] ||= {}
  })

  frcp.wishlist.data.sharedWishlistSlugs = frcp.wishlist.data.sharedWishlistSlugs || {}
  if (frcp.wishlist.data.sharedWishlistSlug) frcp.wishlist.data.sharedWishlistSlugs[DEFAULT_LIST] = frcp.wishlist.data.sharedWishlistSlug
}

function syncGuestAndStore() {
  frcp.wishlist.data.guest = objectUtils.deepMerge({}, EMPTY_GUEST_DATA, frcp.wishlist.data.guest)
  if (!frcp.wishlist.profile.id || !frcp.wishlist.data.guest.guestId) {
    window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
    return
  }

  let guestItemsCount = 0
  // ensure that guest list is part of current active lists
  let list = frcp.wishlist.data.guest.list
  if (frcp.wishlist.data.listNames.indexOf(list) < 0) list = frcp.wishlist.data.activeList

  // updateList is idenpotent so it can be run multiple times 
  Object.keys(frcp.wishlist.data.guest.add).forEach(function (handle) {
    frcp.wishlist.data.guest.add[handle].forEach(variantId => updateList(handle, variantId, false, list))
    guestItemsCount += 1
  })

  Object.keys(frcp.wishlist.data.guest.remove).forEach(function (handle) {
    frcp.wishlist.data.guest.remove[handle].forEach(variantId => updateList(handle, variantId, true, list))
    guestItemsCount += 1
  })

  if (guestItemsCount == 0) {
    window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
    return
  }

  // on account page this code is run by both wishlist and account page js. It should ran once once
  if (frcp.wishlist.guestSyncing) return;
  frcp.wishlist.guestSyncing = true

  const input = {
    customerExternalId: frcp.wishlist.profile.id,
    froonzeToken: frcp.wishlist.profile.froonzeToken,
    guestId: frcp.wishlist.data.guest.guestId,
    add: frcp.wishlist.data.guest.add,
    remove: frcp.wishlist.data.guest.remove,
    list: list,
    addIds: frcp.wishlist.data.guest.addProductId,
    removeIds: frcp.wishlist.data.guest.removeProductId,
  }

  requester.syncGuestWishlist(
    input,
    () => {
      frcp.wishlist.data.updatedAt = new Date().valueOf()
      frcp.wishlist.data.guest = EMPTY_GUEST_DATA
      window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
    },
    () => { }
  )
}

function activateList(list) {
  sync()
  frcp.wishlist.data.activeList = list
  if (frcp.wishlist.data.listNames.indexOf(list) < 0) frcp.wishlist.data.listNames.push(list)
  frcp.wishlist.data.updatedAt = new Date().valueOf()

  window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
}

function createList(list) {
  sync()
  if (frcp.wishlist.data.listNames.indexOf(list) < 0) {
    frcp.wishlist.data.listNames.push(list)
    frcp.wishlist.data.activeList = list
    frcp.wishlist.data.updatedAt = new Date().valueOf() - 1000

    window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
  }
}

function deleteList(list) {
  sync()
  if (frcp.wishlist.data.listNames.indexOf(list) >= 0) {
    frcp.wishlist.data.listNames = frcp.wishlist.data.listNames.filter(l => l !== list)
    delete frcp.wishlist.data.lists[list]
    delete frcp.wishlist.data.product_id_lists[list]
    frcp.wishlist.data.updatedAt = new Date().valueOf() - 1000

    window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
  }
}

function editList(oldList, newList) {
  sync()
  const index = frcp.wishlist.data.listNames.indexOf(oldList)
  const indexNewList = frcp.wishlist.data.listNames.indexOf(newList)
  if (index >= 0) {
    if (indexNewList >= 0) {
      frcp.wishlist.data.listNames = frcp.wishlist.data.listNames.filter(l => l !== oldList)
      frcp.wishlist.data.lists[newList] ||= {}
      objectUtils.deepMerge(frcp.wishlist.data.lists[newList], frcp.wishlist.data.lists[oldList] || {})
      frcp.wishlist.data.product_id_lists[newList] ||= {}
      objectUtils.deepMerge(frcp.wishlist.data.product_id_lists[newList], frcp.wishlist.data.product_id_lists[oldList] || {})

    } else {
      frcp.wishlist.data.lists[newList] = frcp.wishlist.data.lists[oldList]
      frcp.wishlist.data.product_id_lists[newList] = frcp.wishlist.data.product_id_lists[oldList]
      frcp.wishlist.data.listNames[index] = newList
      frcp.wishlist.data.activeList = newList
    }

    delete frcp.wishlist.data.lists[oldList]

    frcp.wishlist.data.updatedAt = new Date().valueOf() - 1000

    window.localStorage.setItem('frcp_wishlist', JSON.stringify(frcp.wishlist.data))
  } else {
    createList(newList)
  }
}
